(ns teamoesterreich.admin-mode.administration.messages.message-list
  (:require ["react-virtualized" :as rv]
            [clojure.string :as string]
            [clojure.string]
            [reagent.core :as r]
            [teamoesterreich.view-state :as v-state]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.organisation :as d-organisation]
            [teamoesterreich.admin-mode.data.userMessages :as d-userMessages]
            [teamoesterreich.admin-mode.component.org-selector :as org-selector]
            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.info :refer [info]]
            ))





(defn datetime-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [:span (if (> (count cell-data) 10)
               (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4) " " (subs cell-data 9 11) ":" (subs cell-data 11 13))
               "-")])))

(defn org-renderer [ALL_DST_LIST]
  (fn [js-parm]
    (let [{rowData "rowData"} (js->clj js-parm)
          cell-data (get rowData "_orgId")]
      ;(js/console.log "rowData" (clj->js (get rowData "orgId")))
      (r/as-element
        [:span (or (get ALL_DST_LIST cell-data) (str "" cell-data))]))))

;:userMessage-uuid
;:userMessage-type
;:userMessage-responseUntil
;:userMessage-message
;:userMessage-longContent
;:userMessage-imageUri
;:userMessage-date
;:userMessage-toDate
;:userMessage-published
;:userMessage-trainingMember
;:userMessage-responseKey
;:userMessage-trainingMemberUuid


(defn inside-table [!st rows]

  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])

          _ (d-organisation/get-store-organisations)
          !organisations (r/cursor v-state/app-state [:organisations])
          ALL_DST_LIST (or (into {} (d-organisation/get-all-multi-filter-list @!organisations)) {})
          ]
      (r/as-element
        [:> rv/Table
         {:headerHeight    50
          :height          height
          :rowCount        (count rows)
          :rowGetter       (fn [i]
                             ;(println (str "rowGet " (aget i "index")))
                             (clj->js (nth rows (aget i "index"))))
          :rowClassName    (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort            (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection")) :invalidated true))
          :sortBy          @!sort
          :sortDirection   (if @!reverse "DESC" "ASC")
          :rowHeight       45
          :width           width
          :headerClassName "headerColumn"
          :className       "UserMessageList"}
         ;(log/debug "rerender " m " @!show-inactive " " @!sort " @!sort " @!reverse " @!reverse rows)


         [:> rv/Column
          {:label        "Zeit"
           :dataKey      (name :userMessage-date)
           :cellRenderer datetime-renderer
           :className    "bordered exampleColumn"
           :style        #js {:overflow "hidden" :textAlign "left"}
           :width        250}]


         [:> rv/Column
          {:label     "Vorname"
           :dataKey   (name :_user-firstName)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     200}]

         [:> rv/Column
          {:label     "Nachname"
           :dataKey   (name :_user-lastName)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     200}]

         [:> rv/Column
          {:label        "Dienststelle"
           :cellRenderer (org-renderer ALL_DST_LIST)
           :dataKey      (name :_orgId)
           :className    "bordered exampleColumn"
           :width        120}]

         [:> rv/Column
          {:label     "Nachrichtentyp"
           :dataKey   (name :_userMessageType)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     200}]



         [:> rv/Column
          {:label     "Titel"
           :dataKey   (name :userMessage-title)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     250}]

         [:> rv/Column
          {:label     "Nachricht"
           :dataKey   (name :userMessage-message)
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden" :textAlign "left"}
           :width     250}]

         ]))))


(defn enrich-data-fn [entry dep-list]
  (let [mask (str (:organisation-key entry))
        entry (merge entry
                     [:_organisationDepartment (or (get dep-list mask)
                                                   (reduce (fn [c [m n]]
                                                             ;(log/debug "find dep m:" m " t:" mask)
                                                             (if (re-find (re-pattern m) mask) n c)) "-" dep-list))]
                     )]
    ;(log/debug "enrich-data-fn " (clj->js entry) (clj->js dep-list))
    entry
    ))

(defn filter-fn [data !st]
  ;(log/debug "filter-fn " (count data) (:filter @!st) (:search @!st))
  (let [org-filter-pattern (re-pattern (or (get-in @!st [:filter :regFilter-organizationDepartment]) (get-in @!st [:filter :regFilter-organizationMain]) ".*"))]
    (filter (fn [[k e]]
              ;(log/debug "filter-fn " (:filter @!st) (:search @!st))
              (and
                ; inactive
                ;:organisationDepartment
                (re-matches org-filter-pattern (str (:organisation-key e)))

                ;search
                (re-find (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split (:search @!st) " ")))
                         (str (:_user-firstName e) "#" (:_user-lastName e) "#" (:userMessage-message e) "#" (:userMessage-title e)))))
            data)))

(defn update-list [!st dep-list]
  (h/update-table-list !st d-userMessages/get-messages {:filter-fn filter-fn :default-sort :userMessage-date :default-reverse true :data-walk-fn (fn [entry] (enrich-data-fn entry dep-list))}))




(defn get-table [!st !rows]
  (fn [] [:> rv/AutoSizer
          {:style {:backgroundColor "red"}
           :sort  (str "rerender !st" @!st)}
          (inside-table !st @!rows)]))


(defn get-it []
  (let [!st (r/atom {:rows {} :loaded nil})
        !sort (r/cursor !st [:sort])
        !reverse (r/cursor !st [:sort])]
    (fn []
      (js/console.log "Mount message-map sort:" (clj->js @!sort) "  reverse:" (clj->js @!reverse))
      (let [!invalidated (r/cursor !st [:invalidated])
            !search (r/cursor !st [:search])
            !filter (r/cursor !st [:filter])
            !loaded? (r/cursor !st [:loaded])
            !rows (r/cursor !st [:rows])
            !waiting? (r/cursor !st [:waiting])

            !organisations (r/cursor v-state/app-state [:organisations])
            dep-mask-list (or (d-organisation/get-lv-filter-list @!organisations) [])
            ]
        (update-list !st dep-mask-list)
        (if (not @!loaded?)
          (do
            [:div {:style {:marginTop "100px"}} [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}] "  loading..."])
          [mui/paper

           [mui/grid
            {:container  true
             :direction  "row"
             :alignItems "stretch"
             :justify    "flex-start"
             :spacing    1
             :style      {:marginTop "15px" :height "calc(100% - 20px)" :minHeight "400px"}
             }

            [mui/grid
             {:item true
              :md   3
              :xs   3
              }]

            [mui/grid
             {:item true
              :md   6
              :xs   6
              :type {:textAlign "bottom"}
              }
             [mui/typography {:variant "h5" :padding "5px 0 0 0"} " Nachrichten der letzten  30 Tage"]
             ]
            [mui/grid
             {:item true
              :md   3
              :xs   3
              }
             [ws-event-sync-component/ws-event-reload !loaded? :userMessages]]

            [mui/grid
             {:item true
              :md   4
              :xs   3
              }

             [mui/text-field
              {:default-value   (str @!search)
               :label           "Suche"
               :fullWidth       true
               :placeholder     "Suche in Liste ..."
               :InputLabelProps {:disableAnimation true :shrink true}
               :style           {:display "inline-block"}
               :onChange        (h/wait-do !waiting? (fn [e] (reset! !search e) (reset! !invalidated true)))
               :multiline       false}]
             ]
            [mui/grid
             {:item true
              :md   4
              :xs   6
              }
             [org-selector/get-selector-org !filter (fn [] (reset! !invalidated true)) (d-rights/get-rights-orgId-filter d-rights/ADMIN)]
             ]
            [mui/grid
             {:item  true
              :md    4
              :xs    3
              :style {:text-align "right"}
              }]

            [mui/grid
             {:item  true
              :xs    12
              :style {:height "calc(100% - 50px)"}
              }
             [get-table !st !rows]]
            ]

           ]))
      )))









